import React from 'react';
import {Translate} from '../../../config/TranslationProvider';

const SubmitButton = ({className}) => (
    <button
        type="submit"
        className={className}
    >
        <Translate value="search" />
    </button>
);

export default SubmitButton;
